import { render, staticRenderFns } from "./SituationReportingFilter.vue?vue&type=template&id=fa4d636a&scoped=true"
import script from "./SituationReportingFilter.vue?vue&type=script&lang=js"
export * from "./SituationReportingFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4d636a",
  null
  
)

export default component.exports